import { configure, extend } from 'vee-validate';
import { confirmed, max, min, required } from 'vee-validate/dist/rules';
import i18n from './i18n';
import { validatePassword } from './modules/forms/validatePassword';

configure({
  i18n,
  defaultMessage: (_, values) =>
    i18n.t(`validations.${values._rule_}`, values)
});

const password = {
  validate (value, [requirements]) {
    if (!requirements) {
      requirements = validatePassword(value);
    }
    return requirements.isValid;
  }
};

const rules = {
  confirmed,
  max,
  min,
  password,
  required
};
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
